module.exports = __webpack_public_path__ + "static/media/bg5.52b89dd8.png";